<main class="shipping-failed">
  <div class="shipping-failed__icon">
    <span class="pds-icon">wrong_location</span>
  </div>
  <h2 class="shipping-failed__title">{{ failure?.title || title }}</h2>
  <p class="shipping-failed__description">{{ failure?.description || description }}</p>
  <button class="ds-button --is-secondary" (click)="onClickRetry()">tentar novamente</button>
</main>
